import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "~be/router/index";

export const trpc = createTRPCReact<AppRouter>();
